import { FC } from 'react';
import { TrendUp, TrendDown, Minus } from '@phosphor-icons/react';
import type { IStatsAggregates } from '../../../models/trainingStatistics';
import styles from './ComparePeriodSummary.module.scss';

/**
 * Confronto periodo corrente vs periodo precedente (Dashboard Stats).
 * Spec v1.1.1 sez 21 righe 2968-2976.
 */
export const ComparePeriodSummary: FC<{
  current: IStatsAggregates;
  previous: IStatsAggregates;
}> = ({ current, previous }) => {
  const deltas = [
    {
      label: 'Minuti totali',
      curr: current.totalMinutes ?? 0,
      prev: previous.totalMinutes ?? 0,
    },
    {
      label: 'Sessioni',
      curr: current.totalSessions ?? 0,
      prev: previous.totalSessions ?? 0,
    },
    {
      label: 'Blocchi',
      curr: current.totalBlocks ?? 0,
      prev: previous.totalBlocks ?? 0,
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        Confronto con periodo precedente
      </div>
      <div className={styles.grid}>
        {deltas.map(({ label, curr, prev }) => {
          const delta = curr - prev;
          const pct = prev > 0 ? (delta / prev) * 100 : 0;
          const arrow =
            delta > 0 ? (
              <TrendUp size={12} weight="bold" />
            ) : delta < 0 ? (
              <TrendDown size={12} weight="bold" />
            ) : (
              <Minus size={12} weight="bold" />
            );
          return (
            <div key={label} className={styles.item}>
              <span className={styles.itemLabel}>{label}</span>
              <div className={styles.itemRow}>
                <span className={styles.prev}>{prev}</span>
                <span className={styles.arrow}>→</span>
                <span className={styles.curr}>{curr}</span>
                <span
                  className={
                    delta > 0
                      ? styles.deltaUp
                      : delta < 0
                        ? styles.deltaDown
                        : styles.deltaZero
                  }
                >
                  {arrow}
                  {delta >= 0 ? '+' : ''}
                  {pct.toFixed(1)}%
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
